import React, { useEffect, useRef, useState } from "react";
import { Link, useParams } from "react-router-dom";
import axios from "axios";
import { Play, Pause, Mic, ArrowLeft } from "lucide-react";
import { useLang } from "@/context/LangContext";
import { Header } from "@/components/Header";
import { ShareButton } from "@/components/ShareButton";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function VoiceView() {
  const { id } = useParams();
  const { t, fontClass } = useLang();
  const [vm, setVm] = useState(null);
  const [loading, setLoading] = useState(true);
  const [playing, setPlaying] = useState(false);
  const audioRef = useRef(null);

  useEffect(() => {
    let live = true;
    axios.get(`${API}/voice-messages/${id}`).then((r) => { if (live) setVm(r.data); })
      .catch(() => {}).finally(() => { if (live) setLoading(false); });
    return () => { live = false; };
  }, [id]);

  const toggle = () => {
    const a = audioRef.current; if (!a) return;
    if (a.paused) { a.play(); setPlaying(true); } else { a.pause(); setPlaying(false); }
  };

  return (
    <div className="min-h-screen" style={{ background: "var(--bg)" }}>
      <Header showAdmin={false} />
      <div className="max-w-lg mx-auto px-4 sm:px-6 pt-10">
        {loading ? (
          <p className="text-center font-ui py-16" style={{ color: "var(--text-muted)" }}>{t("loading")}</p>
        ) : !vm ? (
          <p className="text-center font-ui py-16" style={{ color: "var(--text-muted)" }}>Not found.</p>
        ) : (
          <div className="rounded-3xl p-8 text-center" style={{ background: "linear-gradient(160deg, #1C140E 0%, #3B2A16 70%, #92400E 150%)", color: "#FFFDF7" }} data-testid="voice-view">
            <span className="grid place-items-center w-20 h-20 rounded-full mx-auto sk-glow" style={{ background: "var(--player-accent)", color: "var(--player-bg)" }}><Mic size={36} /></span>
            {vm.to_name && <p className="font-ui text-sm mt-5" style={{ color: "rgba(255,255,255,0.7)" }}>{t("voice_for")} {vm.to_name}</p>}
            {vm.message && <p className={`${fontClass()} text-xl font-bold mt-2 leading-relaxed`}>"{vm.message}"</p>}
            <button onClick={toggle} data-testid="voice-view-play" className="mt-6 inline-flex items-center gap-2 h-14 px-8 rounded-full font-ui text-lg font-bold" style={{ background: "var(--player-accent)", color: "var(--player-bg)" }}>
              {playing ? <Pause size={24} /> : <Play size={24} fill="currentColor" />} {playing ? t("pause") : t("play")}
            </button>
            <p className="font-ui text-sm mt-6" style={{ color: "rgba(255,255,255,0.75)" }}>— {vm.from_name} 🤍</p>
            <audio ref={audioRef} src={vm.audio_url} onEnded={() => setPlaying(false)} className="hidden" />
            <div className="mt-6 flex justify-center">
              <ShareButton testid="voice-view-share" dark text={`🎙️ A voice message from ${vm.from_name}`} />
            </div>
          </div>
        )}
        <Link to="/rooms/sindu-kamare/voice" className="flex items-center justify-center gap-2 font-ui text-sm font-semibold mt-6" style={{ color: "var(--accent)" }}><ArrowLeft size={16} /> {t("voice_nav")}</Link>
      </div>
    </div>
  );
}
